//import { coursesList } from './courses/courses-list';
//import { coursesAlgoliaSearch } from './search-archive/courses-algolia-search';
import { PEFavorites } from './favorites/favorites';
import { coursesAlgoliaInstantSearch } from './search-archive/courses-algolia-instantsearch';

jQuery(document).ready(function($){
  //coursesList($)
  //coursesAlgoliaSearch($)
  PEFavorites($)
  coursesAlgoliaInstantSearch($)
});
